export function getCurrentVersion() {
  return "v6.2";
}

export default {
  getCurrentVersion,
};
